// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1S6U7","title":"Images45_title__Ebsrh","images":"Images45_images__1xXgU"};